module.exports = __webpack_public_path__ + "img/bg-mision-1-2.42b46b05.jpg";